
    import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ChatGroups extends Vue{
    @Prop({ default: false }) tabTitle!: string;
    @Prop({ default: false }) activeTab!: string;
}
